import React from 'react'
import T from 'prop-types'
import { format } from 'date-fns'
import itLocale from 'date-fns/locale/it'
import { Trans, useTranslation } from 'react-i18next'

import InaccessibleSession from 'components/atoms/InaccessibleSession'

export default function CarsToBuySessionExpired({ session, previousSession }) {
  const { t } = useTranslation()

  return (
    <InaccessibleSession
      to="/cars-booked"
      actionLabel={t('carsToBuy.goToCarsBooked')}
      data-testid="publication-expired"
    >
      {t('carsToBuy.expiredContent')}
      {!!previousSession?.sessionId ? (
        <Trans
          i18nKey="carsToBuy.expiredSession"
          values={{
            attribute: previousSession.sessionId,
          }}
          components={{ bold: <strong /> }}
        />
      ) : (
        t('carsToBuy.expiredSessionUnnamed')
      )}
      {!!session.startsAt && (
        <Trans
          i18nKey="carsToBuy.expiredContentNextStart"
          values={{
            attribute:
              session.startsAt &&
              format(new Date(session.startsAt), t('common.date.format'), {
                locale: itLocale,
              }),
          }}
          components={{ bold: <strong /> }}
        />
      )}
    </InaccessibleSession>
  )
}

CarsToBuySessionExpired.propTypes = {
  session: T.object.isRequired,
  previousSession: T.object,
}
